__turbopack_context__.v({
  "BookmarkTab": "pr1IgG_BookmarkTab",
  "BookmarkTabCount": "pr1IgG_BookmarkTabCount",
  "BookmarkTabIcon": "pr1IgG_BookmarkTabIcon",
  "BookmarkTabItem": "pr1IgG_BookmarkTabItem",
  "BookmarkTabItemText": "pr1IgG_BookmarkTabItemText",
  "BookmarkTabLink": "pr1IgG_BookmarkTabLink",
  "BookmarkTabList": "pr1IgG_BookmarkTabList",
  "BookmarkTabTitle": "pr1IgG_BookmarkTabTitle",
  "Button": "pr1IgG_Button",
  "ButtonChevron": "pr1IgG_ButtonChevron",
  "Category": "pr1IgG_Category",
  "CategoryList": "pr1IgG_CategoryList",
  "Child": "pr1IgG_Child",
  "ChildrenList": "pr1IgG_ChildrenList",
  "CloseButton": "pr1IgG_CloseButton",
  "CloseButtonItem": "pr1IgG_CloseButtonItem",
  "Container": "pr1IgG_Container",
  "Disclaimer": "pr1IgG_Disclaimer",
  "DisclaimerButtonContent": "pr1IgG_DisclaimerButtonContent",
  "DisclaimerButtonLink": "pr1IgG_DisclaimerButtonLink",
  "DisclaimerModalButton": "pr1IgG_DisclaimerModalButton",
  "DisclaimerText": "pr1IgG_DisclaimerText",
  "DisclaimerWrapper": "pr1IgG_DisclaimerWrapper",
  "Footer": "pr1IgG_Footer",
  "FooterButton": "pr1IgG_FooterButton",
  "FooterButtons": "pr1IgG_FooterButtons",
  "GrandChildList": "pr1IgG_GrandChildList",
  "HasMultiple": "pr1IgG_HasMultiple",
  "Header": "pr1IgG_Header",
  "HeaderList": "pr1IgG_HeaderList",
  "HeaderListItem": "pr1IgG_HeaderListItem",
  "Icon": "pr1IgG_Icon",
  "IconWrapper": "pr1IgG_IconWrapper",
  "Item": "pr1IgG_Item",
  "Item--Active": "pr1IgG_Item--Active",
  "Item--GrandChild": "pr1IgG_Item--GrandChild",
  "Item--LastActive": "pr1IgG_Item--LastActive",
  "ItemButton": "pr1IgG_ItemButton",
  "ItemContent": "pr1IgG_ItemContent",
  "LastActiveItem": "pr1IgG_LastActiveItem",
  "LastActiveLink": "pr1IgG_LastActiveLink",
  "LastActiveLinkIcon": "pr1IgG_LastActiveLinkIcon",
  "Link": "pr1IgG_Link",
  "LinkNotification": "pr1IgG_LinkNotification",
  "LinkText": "pr1IgG_LinkText",
  "List": "pr1IgG_List",
  "Logo": "pr1IgG_Logo",
  "Menu": "pr1IgG_Menu",
  "MenuContent": "pr1IgG_MenuContent",
  "Nav": "pr1IgG_Nav",
  "NavWrapper": "pr1IgG_NavWrapper",
  "NoResults": "pr1IgG_NoResults",
  "NoResultsText": "pr1IgG_NoResultsText",
  "NoResultsTitle": "pr1IgG_NoResultsTitle",
  "Overlay": "pr1IgG_Overlay",
  "Root": "pr1IgG_Root",
  "Root--Expanded": "pr1IgG_Root--Expanded",
  "SecondaryLink": "pr1IgG_SecondaryLink",
  "SecondaryLinks": "pr1IgG_SecondaryLinks",
  "Toggle": "pr1IgG_Toggle",
  "ToggleButton": "pr1IgG_ToggleButton",
  "ToggleButtonText": "pr1IgG_ToggleButtonText",
  "skeleton-loading": "pr1IgG_skeleton-loading",
});
